module.exports = __webpack_public_path__ + "img/truck.f2a18e6f.png";